import { sum } from 'lib/array/arrayUtils'

function getInsuranceCoverAmountFromOrder(order: App.Order) {
  const deposit = order.depositDetails
  const balance = (deposit && !deposit.balance_paid_date) ? deposit.balance_amount : 0
  const paidTotal = sum(order.payments, payment => payment.amount)

  const serviceFee = order.serviceFee?.total || 0

  return paidTotal + balance - serviceFee
}

export default getInsuranceCoverAmountFromOrder
